// extracted by mini-css-extract-plugin
export default {"paper":"BlurPopup_paper__pTMx-","header":"BlurPopup_header__CTFT3"};